<div class="container-fluid wrapper-page">
  <div align="center" class="page-head">
    <h4 class="mt-2 mb-2">DOCTOR PROFILE</h4>
  </div>
  <div>
    <h5><a href="javascript:void(0)"><i class="fa fa-arrow-circle-left" (click)="getback()"> BACK
        </i></a>
    </h5>
  </div>

  <div class="row">
    <div class="col-lg-12 col-12 col-md-12 col-sm-12">
      <div class="card m-b-30">
        <div class="card-body">
          <ul role="tablist">
            <li role="tab" *ngFor="let tab of doctorListofTab;let i=index">
              <a class="nav-link" (click)="forms[doctorCurrentTab].valid ? doctorAssignTab(tab.id) : false"
                [ngClass]="{'active':doctorCurrentTab == tab.id}" href="javascript:void(0)" role="tab"><span
                  class="number">{{i+1}}.</span>{{tab.title}}</a>
            </li>
          </ul>

          <!--============= Personal Information ============ -->
          <ng-container>
            <section class="mt-35 ml-2 align-items-center text-center" *ngFor="let tab of doctorListofTab">
              <form [formGroup]="forms[tab.id]" *ngIf="doctorCurrentTab == tab.id && form_fields[tab.id]">
                <div class="row cust_row">
                  <div class="col-12 col-sm-12" *ngIf="doctorCurrentTab === 'additionalInformation'">
                    <div class="form-group">
                      <label class="col-lg-12 control-label "><strong>Additional Information:</strong>
                        Please specify any additional information.</label>
                    </div>
                  </div>
                  <div [ngClass]="field.class" *ngFor="let field of form_fields[tab.id]">
                    <sd-form-field [form]="forms[tab.id]" [applicationFormField]="field">
                    </sd-form-field>
                  </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12" *ngIf="doctorCurrentTab=='personalInformation'">
                    <app-drag-drop class="file-container" (fileSelected)="fileSelected($event)"
                      [supportedFormats]="'.png,.jpeg'" [multiple]="false"></app-drag-drop>
                  </div>
                </div>
              </form>
            </section>
          </ng-container>

          <!--============= Speciality ============ -->

          <ng-container *ngIf="doctorCurrentTab=='speciality'">
            <section class="mt-3 ml-2 align-items-center text-center">
              <form [formGroup]="forms['speciality']">
                <div class="row cust_row">
                  <div class="col-sm-12">
                    <div class="form-group" formArrayName="physician_speciality"
                      *ngFor="let item of forms['speciality'].get('physician_speciality')['controls']; let i = index;">
                      <div class="row" [formGroupName]="i">

                        <div class="col-12 col-sm-12 col-md-5 m-m">
                          <select class="form-control" name="expertise" formControlName="speciality_id"
                            [ngClass]="{ 'is-invalid':formValidation(i, 'speciality_id', 'physician_speciality') }">
                            <option *ngFor="let x of specialitiesList" [value]="x.id">{{x.name}}</option>
                          </select>
                          <div *ngIf="formValidation(i, 'speciality_id', 'physician_speciality')"
                            class="invalid-feedback">
                            This is
                            required</div>
                        </div>
                        <div class="col-8 col-sm-10 col-md-5 m-m">
                          <select class="form-control" formControlName="no_of_years"
                            [ngClass]="{ 'is-invalid':formValidation(i, 'no_of_years', 'physician_speciality') }">
                            <option hidden>Select Year</option>
                            <option *ngFor="let year of sp_years" [value]="year.key">{{year.value}}
                            </option>
                          </select>
                          <div *ngIf="formValidation(i, 'no_of_years', 'physician_speciality')"
                            class="invalid-feedback">
                            This is
                            required</div>
                        </div>
                        <div class="col-4 col-sm-2 col-md-1 m-m text-right">
                          <button *ngIf="i > 0" type="button" class="btn btn-outline-primary removeitem"
                            style="padding: 12px 16px;" (click)="removingCurrentSpeciality(i)"><i
                              class="fa fa-close"></i></button>
                        </div>
                        <div class="col-4 col-sm-2 col-md-1 m-m text-right">
                          <button type="button" class="btn btn-outline-primary addmore" style="padding: 12px 16px;"
                            (click)="addingSpeciality();"><i class="fa fa-plus"></i></button>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </section>
          </ng-container>
          <!--============= Education ============ -->
          <ng-container *ngIf="doctorCurrentTab=='education'">
            <section class="mt-3 ml-2 align-items-center text-center">
              <form [formGroup]="forms['education']">
                <div class="row cust_row edication">

                  <div class="col-sm-12">
                    <div class="form-group" formArrayName="physician_education"
                      *ngFor="let item of forms['education'].get('physician_education')['controls']; let i = index;">
                      <div class="row" [formGroupName]="i">
                        <div class="col-12 col-sm-12 col-md-2 m-m">
                          <input id="text" name="degree" type="text" class="form-control" placeholder="Graduation"
                            formControlName="degree"
                            [ngClass]="{ 'is-invalid':formValidation(i, 'degree', 'physician_education') }">
                          <div *ngIf="formValidation(i, 'degree', 'physician_education')" class="invalid-feedback">This
                            is
                            required</div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-2 m-m">
                          <input id="text" name="institution" type="text" class="form-control"
                            placeholder="School/University" formControlName="institution"
                            [ngClass]="{ 'is-invalid':formValidation(i, 'institution', 'physician_education') }">
                          <div *ngIf="formValidation(i, 'institution', 'physician_education')" class="invalid-feedback">
                            This is
                            required</div>

                        </div>
                        <div class="col-6 col-sm-6 col-md-2 m-m text-right">
                          <input id="text" name="from_year" type="number" class="form-control" placeholder="From Year"
                            formControlName="from_year" max="9999"
                            [ngClass]="{ 'is-invalid':formValidation(i, 'from_year', 'physician_education') }">
                          <div *ngIf="formValidation(i, 'from_year', 'physician_education')" class="invalid-feedback">
                            Invalid</div>
                        </div>
                        <div class="col-6 col-sm-5 col-md-2 m-m text-right">
                          <input id="text" name="to_year" type="number" class="form-control" placeholder="To Year"
                            formControlName="to_year" max="9999"
                            [ngClass]="{ 'is-invalid':formValidation(i, 'to_year', 'physician_education') }">
                          <div *ngIf="formValidation(i, 'to_year', 'physician_education')" class="invalid-feedback">
                            Invalid</div>
                        </div>
                        <div class="col-9 col-sm-5 col-md-1 m-m text-right">
                          <select class="form-control" name="country" formControlName="country">
                            <option value="null">Country</option>
                            <option *ngFor="let x of countries" [value]="x.id">{{x.code}} - {{x.name}}</option>
                          </select>
                        </div>

                        <div class="col-md-1" *ngIf="i > 0">
                          <button type="button" class="btn btn-outline-primary removeitem" style="padding: 12px 16px;"
                            (click)="removingCurrentEducation(i)"><i class="fa fa-close"></i></button>
                        </div>
                        <div class="margin-left-3 col-md-1">
                          <button type="button" class="btn btn-outline-primary addmore" style="padding: 12px 16px;"
                            (click)="addingMoreEducation();"><i class="fa fa-plus"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </section>
          </ng-container>

          <!--============= Expeience ============ -->
          <ng-container *ngIf="doctorCurrentTab=='experience'">

            <section class="mt-3 ml-2 align-items-center text-center">
              <form [formGroup]="forms['experience']">
                <div class="row cust_row edication">

                  <div class="col-sm-12">
                    <div class="form-group" formArrayName="physician_experience"
                      *ngFor="let item of forms['experience'].get('physician_experience')['controls']; let i = index;">
                      <div class="row" [formGroupName]="i">
                        <div class="col-12 col-sm-12 col-md-2 m-m">
                          <input id="text" name="institution" type="text" class="form-control"
                            placeholder="Organization" formControlName="employer"
                            [ngClass]="{ 'is-invalid':formValidation(i, 'employer', 'physician_experience') }">
                          <div *ngIf="formValidation(i, 'employer', 'physician_experience')" class="invalid-feedback">
                            This is required</div>
                        </div>
                        <div class="col-6 col-sm-6 col-md-2 m-m">
                          <input id="text" name="designation" type="text" class="form-control" placeholder="Job Title"
                            formControlName="designation"
                            [ngClass]="{ 'is-invalid':formValidation(i, 'designation', 'physician_experience') }">
                          <div *ngIf="formValidation(i, 'designation', 'physician_experience')"
                            class="invalid-feedback">
                            This
                            is
                            required</div>
                        </div>
                        <div class="col-6 col-sm-6 col-md-1 m-m text-right">
                          <input id="text" name="blood" type="text" class="form-control" placeholder="From Year"
                            formControlName="from_year"
                            [ngClass]="{ 'is-invalid':formValidation(i, 'from_year', 'physician_experience') }">
                          <div *ngIf="formValidation(i, 'from_year', 'physician_experience')" class="invalid-feedback">
                            Invalid</div>
                        </div>
                        <div class="col-5 col-sm-5 col-md-1 m-m text-right">
                          <input id="text" name="blood" type="number" class="form-control" placeholder="To Year"
                            formControlName="to_year"
                            [ngClass]="{ 'is-invalid':formValidation(i, 'to_year', 'physician_experience') }">
                          <div *ngIf="formValidation(i, 'to_year', 'physician_experience')" class="invalid-feedback">
                            Invalid</div>
                        </div>
                        <div class="col-5 col-sm-5 col-md-2 m-m text-right">
                          <select class="form-control" name="country" formControlName="country"
                            [ngClass]="{ 'is-invalid':formValidation(i, 'country', 'physician_experience') }">
                            <option value="null">Country</option>
                            <option *ngFor="let x of countries" [value]="x.id">{{x.code}} - {{x.name}}</option>
                          </select>
                        </div>

                        <div class="col-md-1" *ngIf="i > 0">
                          <button type="button" class="btn btn-outline-primary removeitem" style="padding: 12px 16px;"
                            (click)="removingCurrentExperince(i)"><i class="fa fa-close"></i></button>
                        </div>
                        <div class="margin-left-1 col-md-1">
                          <button type="button" class="btn btn-outline-primary addmore" style="padding: 12px 16px;"
                            (click)="addingMoreExperience();"><i class="fa fa-plus"></i></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </section>
          </ng-container>

        </div>
      </div>
    </div>
  </div>
  <!-- END ROW -->
  <div class="row">
    <div class="col-10"></div>
    <div class="col-2">
      <button type="button" class="btn btn-primary btn-doctor" *ngIf="doctorCurrentTab != 'personalInformation'"
        (click)="doctorPreviousTab()">Previous</button>
      <button type="button" class="btn btn-primary btn-doctor pull-right" [disabled]="forms[doctorCurrentTab].invalid"
        *ngIf="doctorCurrentTab != 'additionalInformation'" (click)="doctorNextTab()">Next</button>
      <button type="button" class="btn btn-primary btn-doctor pull-right"
        *ngIf="doctorCurrentTab == 'additionalInformation'" (click)="saveDoctor()">Save</button>
    </div>
  </div>

</div>